export default __webpack_public_path__ + "static/media/down-arrow.3b260191.svg";